module.exports = __webpack_public_path__ + "static/media/mark-3.7e0ec113.svg";